import { render, staticRenderFns } from "./VxTableFilters.vue?vue&type=template&id=20ff99a1&"
import script from "./VxTableFilters.vue?vue&type=script&lang=js&"
export * from "./VxTableFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports